module.exports = __webpack_public_path__ + "static/media/peacock-day.9bb72521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/peacock-day.jpg
// module id = 1628
// module chunks = 0